
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careerguide/[:slug]",
      function () {
        return require("private-next-pages/careerguide/[:slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/careerguide/[:slug]"])
      });
    }
  